//#region \0rolldown/runtime.js
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJSMin = (cb, mod) => () => (mod || (cb((mod = { exports: {} }).exports, mod), cb = null), mod.exports);
var __copyProps = (to, from, except, desc) => {
	if (from && typeof from === "object" || typeof from === "function") for (var keys = __getOwnPropNames(from), i = 0, n = keys.length, key; i < n; i++) {
		key = keys[i];
		if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
			get: ((k) => from[k]).bind(null, key),
			enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
		});
	}
	return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(isNodeMode || !mod || !mod.__esModule || !__hasOwnProp.call(mod, "default") ? __defProp(target, "default", {
	value: mod,
	enumerable: true
}) : target, mod));
//#endregion
//#region packages/game-core/src/content.js
var require_content = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var DEFAULT_ATTR_KEYS = [
		"asset",
		"intel",
		"luck",
		"face",
		"ability",
		"fame",
		"feel"
	];
	var DEFAULT_SCHEMA_VERSION = 2;
	function isPlainObject(value) {
		return !!value && Object.prototype.toString.call(value) === "[object Object]";
	}
	function normalizeContent(input) {
		const source = input || {};
		const branchNodes = source.branchNodes || source.BRANCH_NODES || {};
		return {
			schemaVersion: source.schemaVersion || source.STATE_SCHEMA_VERSION || DEFAULT_SCHEMA_VERSION,
			attrKeys: Array.isArray(source.attrKeys) ? source.attrKeys.slice() : DEFAULT_ATTR_KEYS.slice(),
			deathTypes: source.deathTypes || source.DEATH_TYPES || {},
			nodes: Array.isArray(source.nodes) ? source.nodes : Array.isArray(source.NODES) ? source.NODES : [],
			fateLines: Array.isArray(source.fateLines) ? source.fateLines : Array.isArray(source.FATE_LINES) ? source.FATE_LINES : [],
			branchNodes,
			endings: Array.isArray(source.endings) ? source.endings : Array.isArray(source.ENDINGS) ? source.ENDINGS : [],
			achievements: Array.isArray(source.achievements) ? source.achievements : Array.isArray(source.ACHIEVEMENTS) ? source.ACHIEVEMENTS : [],
			lifeTitles: Array.isArray(source.lifeTitles) ? source.lifeTitles : Array.isArray(source.LIFE_TITLES) ? source.LIFE_TITLES : [],
			hotspots: Array.isArray(source.hotspots) ? source.hotspots : Array.isArray(source.HOTSPOTS) ? source.HOTSPOTS : [],
			specialEggs: source.specialEggs || {}
		};
	}
	function idsOf(list) {
		return (Array.isArray(list) ? list : []).filter((item) => isPlainObject(item) && typeof item.id === "string").map((item) => item.id);
	}
	function getMainNode(content, index) {
		const c = normalizeContent(content);
		return Number.isInteger(index) && index >= 0 && index < c.nodes.length ? c.nodes[index] : null;
	}
	function getMainNodeById(content, id) {
		const c = normalizeContent(content);
		return typeof id === "string" ? c.nodes.find((node) => node && node.id === id) || null : null;
	}
	function getBranchNode(content, id) {
		const c = normalizeContent(content);
		return typeof id === "string" && isPlainObject(c.branchNodes) ? c.branchNodes[id] || null : null;
	}
	function getFateLine(content, id) {
		const c = normalizeContent(content);
		return typeof id === "string" ? c.fateLines.find((line) => line && line.id === id) || null : null;
	}
	function getEndingById(content, id) {
		const c = normalizeContent(content);
		return typeof id === "string" ? c.endings.find((ending) => ending && ending.id === id) || null : null;
	}
	function getAllowedDeathTypes(content) {
		const c = normalizeContent(content);
		return Object.keys(c.deathTypes).filter((key) => typeof key === "string");
	}
	function contentSummary(content) {
		const c = normalizeContent(content);
		return {
			nodes: c.nodes.length,
			fateLines: c.fateLines.length,
			branchNodes: isPlainObject(c.branchNodes) ? Object.keys(c.branchNodes).length : 0,
			endings: c.endings.length,
			deathTypes: getAllowedDeathTypes(c),
			achievements: c.achievements.length,
			lifeTitles: c.lifeTitles.length
		};
	}
	module.exports = {
		DEFAULT_ATTR_KEYS,
		DEFAULT_SCHEMA_VERSION,
		contentSummary,
		getAllowedDeathTypes,
		getBranchNode,
		getEndingById,
		getFateLine,
		getMainNode,
		getMainNodeById,
		idsOf,
		isPlainObject,
		normalizeContent
	};
}));
//#endregion
//#region packages/game-core/src/state.js
var require_state = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var { DEFAULT_ATTR_KEYS, DEFAULT_SCHEMA_VERSION, getAllowedDeathTypes, getBranchNode, getEndingById, getFateLine, getMainNode, isPlainObject, normalizeContent, idsOf } = require_content();
	var AUX_KEYS = [
		"black",
		"risk",
		"rep",
		"clean"
	];
	var DELTA_KEYS = DEFAULT_ATTR_KEYS.concat(AUX_KEYS);
	var PHASES = [
		"choosing",
		"result",
		"dead",
		"fatePrompt",
		"ended"
	];
	var COLLECTION_KEYS = [
		"deaths",
		"endingsCollected",
		"fateCollected",
		"eggs",
		"achievements",
		"lifeTitles"
	];
	var SERIALIZED_KEYS = [
		"schemaVersion",
		"nodeIdx",
		"attrs",
		"black",
		"risk",
		"rep",
		"clean",
		"flags",
		"nodePicks",
		"nodeDeltas",
		"branchPicks",
		"revives",
		"deaths",
		"endingsCollected",
		"fateCollected",
		"eggs",
		"achievements",
		"lifeTitles",
		"totalDeaths",
		"totalPlays",
		"legacyTotalPlays",
		"completedRuns",
		"dualPicks",
		"lastHotIdx",
		"lastHotDelta",
		"done",
		"inFate",
		"fateLineId",
		"mode",
		"branchIdx",
		"phase",
		"pendingResult",
		"deathInfo",
		"endingInfo",
		"runStarted",
		"lastDelta",
		"lastHot",
		"power",
		"adPower",
		"adRevives",
		"adDate",
		"pendingEggs"
	];
	var SaveMigrationError = class extends Error {
		constructor(code, message, details) {
			super(message);
			this.name = "SaveMigrationError";
			this.code = code;
			this.details = details || null;
		}
	};
	function clone(value) {
		if (Array.isArray(value)) return value.map(clone);
		if (isPlainObject(value)) {
			const out = {};
			Object.keys(value).forEach((key) => {
				out[key] = clone(value[key]);
			});
			return out;
		}
		return value;
	}
	function isFiniteNumber(value) {
		return typeof value === "number" && Number.isFinite(value);
	}
	function isIntegerInRange(value, min, max) {
		return Number.isInteger(value) && value >= min && value <= max;
	}
	function uniqueStrings(value, allowed) {
		if (!Array.isArray(value)) return [];
		const seen = /* @__PURE__ */ new Set();
		const out = [];
		value.forEach((item) => {
			if (typeof item !== "string" || seen.has(item)) return;
			if (allowed && !allowed.includes(item)) return;
			seen.add(item);
			out.push(item);
		});
		return out;
	}
	function serializableDelta(value) {
		const out = {};
		if (!isPlainObject(value)) return out;
		DELTA_KEYS.forEach((key) => {
			if (isFiniteNumber(value[key]) && value[key] !== 0) out[key] = value[key];
		});
		return out;
	}
	function sameJsonValue(left, right) {
		if (left === right) return true;
		if (Array.isArray(left) || Array.isArray(right)) {
			if (!Array.isArray(left) || !Array.isArray(right) || left.length !== right.length) return false;
			return left.every((item, index) => sameJsonValue(item, right[index]));
		}
		if (isPlainObject(left) || isPlainObject(right)) {
			if (!isPlainObject(left) || !isPlainObject(right)) return false;
			const leftKeys = Object.keys(left).sort();
			const rightKeys = Object.keys(right).sort();
			if (leftKeys.length !== rightKeys.length || leftKeys.some((key, index) => key !== rightKeys[index])) return false;
			return leftKeys.every((key) => sameJsonValue(left[key], right[key]));
		}
		return false;
	}
	function defaultAttrs(attrKeys) {
		const attrs = {};
		attrKeys.forEach((key) => {
			attrs[key] = 50;
		});
		return attrs;
	}
	function createInitialState(overrides, content) {
		const c = normalizeContent(content);
		const state = {
			schemaVersion: c.schemaVersion || DEFAULT_SCHEMA_VERSION,
			nodeIdx: 0,
			attrs: defaultAttrs(c.attrKeys),
			black: 0,
			risk: 0,
			rep: 0,
			clean: 0,
			flags: {},
			nodePicks: [],
			nodeDeltas: [],
			branchPicks: [],
			revives: 0,
			deaths: [],
			endingsCollected: [],
			fateCollected: [],
			eggs: [],
			achievements: [],
			lifeTitles: [],
			totalDeaths: 0,
			totalPlays: 0,
			legacyTotalPlays: 0,
			completedRuns: 0,
			dualPicks: [],
			lastHotIdx: 17,
			lastHotDelta: null,
			done: false,
			inFate: false,
			fateLineId: null,
			mode: "main",
			branchIdx: null,
			phase: "choosing",
			pendingResult: null,
			deathInfo: null,
			endingInfo: null,
			runStarted: false,
			lastDelta: null,
			lastHot: null,
			power: 5,
			adPower: 5,
			adRevives: 3,
			adDate: "",
			pendingEggs: []
		};
		if (!isPlainObject(overrides)) return state;
		Object.keys(overrides).forEach((key) => {
			if (!SERIALIZED_KEYS.includes(key)) return;
			state[key] = clone(overrides[key]);
		});
		if (isPlainObject(overrides.attrs)) state.attrs = Object.assign(defaultAttrs(c.attrKeys), clone(overrides.attrs));
		return state;
	}
	function normalizeDualPick(value, content) {
		const node = normalizeContent(content).nodes[0];
		if (!isPlainObject(value) || !node || !Array.isArray(node.choices)) return null;
		const sec = isIntegerInRange(value.sec, 0, 2) ? value.sec : null;
		let choiceIdx = value.choiceIdx;
		if (choiceIdx === void 0 && isIntegerInRange(value.choice, 0, node.choices.length - 1)) choiceIdx = value.choice;
		if (choiceIdx === void 0 && isPlainObject(value.choice)) {
			const matches = node.choices.map((choice, index) => ({
				choice,
				index
			})).filter((item) => sameJsonValue(item.choice, value.choice));
			if (matches.length === 1) choiceIdx = matches[0].index;
		}
		if (!isIntegerInRange(choiceIdx, 0, node.choices.length - 1) || sec === null) return null;
		if (!node.choices[choiceIdx] || node.choices[choiceIdx].sec !== sec) return null;
		return {
			sec,
			choiceIdx
		};
	}
	function normalizeBranchPick(value, content) {
		if (!isPlainObject(value) || typeof value.nodeId !== "string") return null;
		const node = getBranchNode(content, value.nodeId);
		if (!node || !Array.isArray(node.choices) || !isIntegerInRange(value.choiceIdx, 0, node.choices.length - 1)) return null;
		return {
			nodeId: value.nodeId,
			choiceIdx: value.choiceIdx,
			result: typeof value.result === "string" ? value.result : "",
			delta: serializableDelta(value.delta)
		};
	}
	function normalizePendingResult(value, content) {
		const c = normalizeContent(content);
		if (!isPlainObject(value) || value.kind !== "main" && value.kind !== "branch" || typeof value.result !== "string") return null;
		if (!isPlainObject(value.delta)) return null;
		if (value.kind === "main") {
			const node = getMainNode(c, value.nodeIdx);
			if (!node || !isIntegerInRange(value.choiceIdx, 0, node.choices.length - 1) || value.nodeId !== node.id) return null;
			const next = isPlainObject(value.next) && isIntegerInRange(value.next.nodeIdx, 0, c.nodes.length) ? value.next.nodeIdx : value.nodeIdx + 1;
			return {
				kind: "main",
				nodeId: node.id,
				nodeIdx: value.nodeIdx,
				choiceIdx: value.choiceIdx,
				title: typeof value.title === "string" ? value.title : "结算",
				result: value.result,
				delta: serializableDelta(value.delta),
				next: {
					kind: "main",
					nodeIdx: next
				}
			};
		}
		const node = getBranchNode(c, value.nodeId);
		if (!node || !isIntegerInRange(value.choiceIdx, 0, node.choices.length - 1)) return null;
		const goto = isPlainObject(value.next) && (value.next.goto === null || typeof value.next.goto === "string") ? value.next.goto : null;
		return {
			kind: "branch",
			nodeId: node.id,
			choiceIdx: value.choiceIdx,
			title: typeof value.title === "string" ? value.title : "结算",
			result: value.result,
			delta: serializableDelta(value.delta),
			next: {
				kind: "branch",
				goto
			}
		};
	}
	function normalizeDeathInfo(value, content, warnings) {
		if (value === null || value === void 0) return null;
		const invalid = (code) => {
			if (Array.isArray(warnings)) warnings.push({
				code,
				path: "deathInfo"
			});
			return null;
		};
		if (!isPlainObject(value) || typeof value.type !== "string") return invalid("DEATH_INFO_INVALID");
		if (!getAllowedDeathTypes(content).includes(value.type)) return invalid("DEATH_TYPE_UNKNOWN");
		return {
			type: value.type,
			text: typeof value.text === "string" ? value.text : "",
			sourceNodeId: typeof value.sourceNodeId === "string" ? value.sourceNodeId : null,
			branchId: typeof value.branchId === "string" ? value.branchId : null
		};
	}
	function normalizeEndingInfo(value, content) {
		if (!isPlainObject(value) || value.kind !== "main" && value.kind !== "fate") return null;
		const out = {
			kind: value.kind,
			endingId: null,
			fateLineId: null,
			variant: null,
			branchId: null,
			nodeId: null,
			year: null,
			age: null,
			legacy: value.legacy === true
		};
		if (value.kind === "main") {
			if (typeof value.endingId === "string" && getEndingById(content, value.endingId)) out.endingId = value.endingId;
		} else {
			if (typeof value.fateLineId === "string" && getFateLine(content, value.fateLineId)) out.fateLineId = value.fateLineId;
			if (value.variant === "high" || value.variant === "cost") out.variant = value.variant;
			if (typeof value.branchId === "string" && getFateLine(content, value.branchId)) out.branchId = value.branchId;
		}
		if (typeof value.nodeId === "string") {
			const main = cMainNode(content, value.nodeId);
			const branch = getBranchNode(content, value.nodeId);
			if (main || branch) out.nodeId = value.nodeId;
		}
		if (typeof value.year === "string") out.year = value.year;
		if (typeof value.age === "string" || typeof value.age === "number") out.age = String(value.age);
		return out;
	}
	function cMainNode(content, id) {
		return normalizeContent(content).nodes.find((node) => node && node.id === id) || null;
	}
	function copyFlags(value) {
		if (!isPlainObject(value)) return {};
		const out = {};
		Object.keys(value).forEach((key) => {
			const item = value[key];
			if (typeof item === "boolean" || typeof item === "string" || isFiniteNumber(item)) out[key] = clone(item);
		});
		return out;
	}
	function copyNodePicks(value, content) {
		const c = normalizeContent(content);
		if (!Array.isArray(value)) return [];
		const out = [];
		for (let i = 0; i < Math.min(value.length, c.nodes.length); i += 1) {
			const item = value[i];
			if (item === -1) {
				out[i] = -1;
				continue;
			}
			const node = c.nodes[i];
			if (item === null || item === void 0) continue;
			if (node && isIntegerInRange(item, 0, node.choices.length - 1)) out[i] = item;
		}
		return out;
	}
	function copyAdDate(value) {
		return typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : "";
	}
	function oldFateId(raw, content) {
		if (typeof raw.fateLineId === "string" && getFateLine(content, raw.fateLineId)) return raw.fateLineId;
		if (isPlainObject(raw.fateLine) && typeof raw.fateLine.id === "string" && getFateLine(content, raw.fateLine.id)) return raw.fateLine.id;
		if (typeof raw.mode === "string" && raw.mode.startsWith("line:") && getFateLine(content, raw.mode.slice(5))) return raw.mode.slice(5);
		return null;
	}
	function pendingResultAligned(state, content) {
		const p = state.pendingResult;
		if (!p) return true;
		if (p.kind === "main") return p.nodeIdx === state.nodeIdx && p.nodeId === (getMainNode(content, state.nodeIdx) || {}).id;
		return p.nodeId === state.branchIdx;
	}
	function migrateState(raw, content, options) {
		const c = normalizeContent(content);
		const warnings = options && Array.isArray(options.warnings) ? options.warnings : [];
		if (!isPlainObject(raw) || Array.isArray(raw)) throw new SaveMigrationError("SAVE_ROOT_INVALID", "存档根节点不是对象");
		const version = raw.schemaVersion === void 0 ? 1 : raw.schemaVersion;
		if (!isIntegerInRange(version, 1, c.schemaVersion)) throw new SaveMigrationError("SAVE_VERSION_UNSUPPORTED", "无法识别的存档版本", { schemaVersion: version });
		const out = createInitialState({}, c);
		c.attrKeys.forEach((key) => {
			if (isPlainObject(raw.attrs) && isFiniteNumber(raw.attrs[key])) out.attrs[key] = raw.attrs[key];
		});
		AUX_KEYS.forEach((key) => {
			if (isFiniteNumber(raw[key])) out[key] = raw[key];
		});
		out.flags = copyFlags(raw.flags);
		out.nodePicks = copyNodePicks(raw.nodePicks, c);
		out.nodeDeltas = Array.isArray(raw.nodeDeltas) ? raw.nodeDeltas.slice(0, c.nodes.length).map(serializableDelta) : [];
		out.dualPicks = [];
		if (Array.isArray(raw.dualPicks)) raw.dualPicks.slice(0, 3).forEach((item) => {
			const normalized = normalizeDualPick(item, c);
			if (normalized) out.dualPicks.push(normalized);
		});
		out.branchPicks = [];
		if (Array.isArray(raw.branchPicks)) raw.branchPicks.forEach((item) => {
			const normalized = normalizeBranchPick(item, c);
			if (normalized) out.branchPicks.push(normalized);
		});
		const deathIds = getAllowedDeathTypes(c);
		out.deaths = uniqueStrings(raw.deaths, deathIds);
		out.endingsCollected = uniqueStrings(raw.endingsCollected, idsOf(c.endings));
		out.fateCollected = uniqueStrings(raw.fateCollected, idsOf(c.fateLines));
		out.eggs = uniqueStrings(raw.eggs);
		out.achievements = uniqueStrings(raw.achievements, idsOf(c.achievements));
		out.lifeTitles = uniqueStrings(raw.lifeTitles, idsOf(c.lifeTitles));
		[
			"revives",
			"totalDeaths",
			"totalPlays",
			"legacyTotalPlays",
			"completedRuns",
			"power",
			"adPower",
			"adRevives"
		].forEach((key) => {
			if (isFiniteNumber(raw[key])) out[key] = Math.max(0, Math.floor(raw[key]));
		});
		out.lastHotIdx = isFiniteNumber(raw.lastHotIdx) ? Math.floor(raw.lastHotIdx) : out.lastHotIdx;
		out.legacyTotalPlays = isFiniteNumber(raw.legacyTotalPlays) ? out.legacyTotalPlays : out.totalPlays;
		out.adDate = copyAdDate(raw.adDate);
		out.lastHot = typeof raw.lastHot === "string" ? raw.lastHot : null;
		out.lastHotDelta = isPlainObject(raw.lastHotDelta) ? serializableDelta(raw.lastHotDelta) : null;
		out.lastDelta = isPlainObject(raw.lastDelta) ? serializableDelta(raw.lastDelta) : null;
		out.nodeIdx = isIntegerInRange(raw.nodeIdx, 0, c.nodes.length) ? raw.nodeIdx : 0;
		out.fateLineId = oldFateId(raw, c);
		out.branchIdx = getBranchNode(c, raw.branchIdx) ? raw.branchIdx : null;
		const rawMode = raw.mode;
		if (rawMode === "ended" || rawMode === "main" || typeof rawMode === "string" && rawMode.startsWith("line:") && getFateLine(c, rawMode.slice(5))) out.mode = rawMode;
		else out.mode = raw.done ? "ended" : out.fateLineId && raw.inFate ? `line:${out.fateLineId}` : "main";
		if (out.mode.startsWith("line:") && !out.fateLineId) out.fateLineId = out.mode.slice(5);
		out.done = raw.done === true || out.mode === "ended";
		out.inFate = !!out.fateLineId || out.mode.startsWith("line:");
		out.pendingResult = normalizePendingResult(raw.pendingResult, c);
		if (raw.pendingResult && !out.pendingResult) warnings.push({
			code: "PENDING_RESULT_DROPPED",
			path: "pendingResult"
		});
		out.deathInfo = normalizeDeathInfo(raw.deathInfo, c, warnings);
		out.endingInfo = normalizeEndingInfo(raw.endingInfo, c);
		if (!out.endingInfo && out.done) {
			out.endingInfo = {
				kind: out.mode.startsWith("line:") ? "fate" : "main",
				endingId: null,
				fateLineId: out.fateLineId,
				variant: null,
				branchId: null,
				nodeId: null,
				year: null,
				age: null,
				legacy: true
			};
			warnings.push({
				code: "LEGACY_ENDING_CONTEXT",
				path: "endingInfo"
			});
		}
		out.phase = "choosing";
		if (out.done) out.phase = "ended";
		else if (out.deathInfo) out.phase = "dead";
		else if (out.pendingResult) out.phase = "result";
		else if (out.inFate && !out.branchIdx) out.phase = "fatePrompt";
		if (PHASES.includes(raw.phase)) {
			if (raw.phase === "ended" && out.done) out.phase = "ended";
			else if (raw.phase === "dead" && out.deathInfo && !out.done) out.phase = "dead";
			else if (raw.phase === "result" && out.pendingResult && !out.done && !out.deathInfo) out.phase = "result";
			else if (raw.phase === "fatePrompt" && out.inFate && !out.branchIdx && !out.done && !out.deathInfo && !out.pendingResult) out.phase = "fatePrompt";
			else if (raw.phase === "choosing" && !out.done && !out.deathInfo && !out.pendingResult && !(out.inFate && !out.branchIdx)) out.phase = "choosing";
		}
		if (!pendingResultAligned(out, c)) {
			out.pendingResult = null;
			if (!out.done && !out.deathInfo) out.phase = out.inFate && !out.branchIdx ? "fatePrompt" : "choosing";
			warnings.push({
				code: "PENDING_RESULT_RELATION_REPAIRED",
				path: "pendingResult"
			});
		}
		if (out.branchIdx) {
			const branch = getBranchNode(c, out.branchIdx);
			if (!branch || !out.fateLineId || branch.line !== out.fateLineId) {
				out.branchIdx = null;
				out.mode = out.fateLineId ? `line:${out.fateLineId}` : "main";
				out.inFate = !!out.fateLineId;
				if (!out.done && !out.deathInfo && !out.pendingResult) out.phase = out.inFate ? "fatePrompt" : "choosing";
				warnings.push({
					code: "BRANCH_RELATION_REPAIRED",
					path: "branchIdx"
				});
			}
		}
		out.runStarted = raw.runStarted === true || out.totalPlays > 0 || out.nodeIdx > 0 || out.dualPicks.length > 0 || out.done || out.inFate;
		out.pendingEggs = [];
		if (Array.isArray(raw.pendingEggs)) raw.pendingEggs.forEach((item) => {
			if (!isPlainObject(item) || typeof item.title !== "string") return;
			out.pendingEggs.push({
				id: typeof item.id === "string" ? item.id : item.title,
				title: item.title,
				text: typeof item.text === "string" ? item.text : ""
			});
		});
		return out;
	}
	function serializeState(state, content) {
		const c = normalizeContent(content);
		const out = {};
		SERIALIZED_KEYS.forEach((key) => {
			if (Object.prototype.hasOwnProperty.call(state || {}, key)) out[key] = clone(state[key]);
		});
		out.schemaVersion = c.schemaVersion || DEFAULT_SCHEMA_VERSION;
		out.attrs = {};
		c.attrKeys.forEach((key) => {
			out.attrs[key] = state && state.attrs ? state.attrs[key] : void 0;
		});
		out.nodeDeltas = Array.isArray(state && state.nodeDeltas) ? state.nodeDeltas.map(serializableDelta) : [];
		out.lastDelta = serializableDelta(state && state.lastDelta);
		out.lastHotDelta = serializableDelta(state && state.lastHotDelta);
		out.pendingResult = state && state.pendingResult ? normalizePendingResult(state.pendingResult, c) : null;
		out.deathInfo = state && state.deathInfo ? normalizeDeathInfo(state.deathInfo, c) : null;
		out.endingInfo = state && state.endingInfo ? normalizeEndingInfo(state.endingInfo, c) : null;
		out.pendingEggs = Array.isArray(state && state.pendingEggs) ? state.pendingEggs.filter((item) => isPlainObject(item) && typeof item.title === "string").map((item) => ({
			id: typeof item.id === "string" ? item.id : item.title,
			title: item.title,
			text: typeof item.text === "string" ? item.text : ""
		})) : [];
		delete out.fateLine;
		return out;
	}
	function parseAndMigrate(rawText, content) {
		let raw;
		try {
			raw = typeof rawText === "string" ? JSON.parse(rawText) : rawText;
		} catch (error) {
			throw new SaveMigrationError("SAVE_JSON_INVALID", "存档 JSON 无法解析");
		}
		const warnings = [];
		return {
			state: migrateState(raw, content, { warnings }),
			warnings,
			migrated: raw.schemaVersion !== (normalizeContent(content).schemaVersion || DEFAULT_SCHEMA_VERSION)
		};
	}
	module.exports = {
		AUX_KEYS,
		COLLECTION_KEYS,
		DELTA_KEYS,
		PHASES,
		SERIALIZED_KEYS,
		SaveMigrationError,
		clone,
		createInitialState,
		isFiniteNumber,
		isIntegerInRange,
		isPlainObject,
		migrateState,
		normalizeBranchPick,
		normalizeDeathInfo,
		normalizeDualPick,
		normalizeEndingInfo,
		normalizePendingResult,
		parseAndMigrate,
		serializableDelta,
		serializeState,
		uniqueStrings
	};
}));
//#endregion
//#region packages/game-core/src/validation.js
var require_validation = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var { AUX_KEYS, COLLECTION_KEYS, DELTA_KEYS, PHASES, SERIALIZED_KEYS, isFiniteNumber, isIntegerInRange, isPlainObject } = require_state();
	var { getAllowedDeathTypes, getBranchNode, getEndingById, getFateLine, getMainNode, getMainNodeById, idsOf, normalizeContent } = require_content();
	function add(errors, path, code, message) {
		errors.push({
			path,
			code,
			message
		});
	}
	function validateDelta(value, path, errors) {
		if (value === null) return;
		if (!isPlainObject(value)) {
			add(errors, path, "DELTA_NOT_OBJECT", "delta 必须是对象");
			return;
		}
		Object.keys(value).forEach((key) => {
			if (!DELTA_KEYS.includes(key)) add(errors, `${path}.${key}`, "DELTA_KEY_UNKNOWN", "delta 含未知字段");
			else if (!isFiniteNumber(value[key])) add(errors, `${path}.${key}`, "DELTA_NOT_FINITE", "delta 必须是有限数字");
		});
	}
	function validateFlags(value, errors) {
		if (!isPlainObject(value)) {
			add(errors, "flags", "FLAGS_NOT_OBJECT", "flags 必须是对象");
			return;
		}
		Object.keys(value).forEach((key) => {
			const item = value[key];
			if (typeof item !== "boolean" && typeof item !== "string" && !isFiniteNumber(item)) add(errors, `flags.${key}`, "FLAG_VALUE_INVALID", "flag 值必须是布尔、字符串或有限数字");
		});
	}
	function validateStringCollection(value, path, allowed, errors, options) {
		if (!Array.isArray(value)) {
			add(errors, path, "COLLECTION_NOT_ARRAY", "集合必须是数组");
			return;
		}
		const seen = /* @__PURE__ */ new Set();
		value.forEach((item, index) => {
			if (typeof item !== "string") {
				add(errors, `${path}[${index}]`, "COLLECTION_ITEM_INVALID", "集合元素必须是字符串");
				return;
			}
			if (seen.has(item)) add(errors, `${path}[${index}]`, "COLLECTION_DUPLICATE", "集合不能重复");
			seen.add(item);
			if (allowed && !allowed.includes(item)) add(errors, `${path}[${index}]`, "COLLECTION_ID_UNKNOWN", "集合含未知 ID");
			if (options && options.maxLength && item.length > options.maxLength) add(errors, `${path}[${index}]`, "COLLECTION_ITEM_TOO_LONG", "集合元素过长");
		});
	}
	function validateDeathInfo(value, content, errors) {
		if (value === null) return;
		if (!isPlainObject(value)) {
			add(errors, "deathInfo", "DEATH_INFO_NOT_OBJECT", "deathInfo 必须是对象或 null");
			return;
		}
		const allowed = getAllowedDeathTypes(content);
		if (typeof value.type !== "string" || !allowed.includes(value.type)) add(errors, "deathInfo.type", "DEATH_TYPE_UNKNOWN", "deathInfo.type 不在死亡类型白名单");
		if (typeof value.text !== "string") add(errors, "deathInfo.text", "DEATH_TEXT_INVALID", "deathInfo.text 必须是字符串");
		if (value.sourceNodeId !== null && value.sourceNodeId !== void 0 && !getMainNodeById(content, value.sourceNodeId) && !getBranchNode(content, value.sourceNodeId)) add(errors, "deathInfo.sourceNodeId", "DEATH_SOURCE_UNKNOWN", "死亡来源节点不存在");
		if (value.branchId !== null && value.branchId !== void 0) {
			const fate = getFateLine(content, value.branchId);
			if (!fate) add(errors, "deathInfo.branchId", "DEATH_BRANCH_UNKNOWN", "死亡来源支线不存在");
			const branch = value.sourceNodeId && getBranchNode(content, value.sourceNodeId);
			if (branch && fate && branch.line !== fate.id) add(errors, "deathInfo.branchId", "DEATH_BRANCH_MISMATCH", "死亡来源节点与支线不一致");
		}
	}
	function validatePendingResult(value, state, content, errors) {
		if (value === null) return;
		if (!isPlainObject(value)) {
			add(errors, "pendingResult", "PENDING_RESULT_NOT_OBJECT", "pendingResult 必须是对象或 null");
			return;
		}
		if (value.kind !== "main" && value.kind !== "branch") add(errors, "pendingResult.kind", "PENDING_KIND_INVALID", "pendingResult.kind 无效");
		if (typeof value.nodeId !== "string" || typeof value.title !== "string" || typeof value.result !== "string") add(errors, "pendingResult", "PENDING_TEXT_INVALID", "pendingResult 文本字段无效");
		validateDelta(value.delta, "pendingResult.delta", errors);
		if (value.kind === "main") {
			const node = getMainNode(content, value.nodeIdx);
			if (!node) add(errors, "pendingResult.nodeIdx", "PENDING_NODE_UNKNOWN", "主线结算节点不存在");
			else {
				if (value.nodeId !== node.id) add(errors, "pendingResult.nodeId", "PENDING_NODE_MISMATCH", "结算节点 ID 不匹配");
				if (!isIntegerInRange(value.choiceIdx, 0, node.choices.length - 1)) add(errors, "pendingResult.choiceIdx", "PENDING_CHOICE_INVALID", "主线选项不存在");
			}
			if (!isIntegerInRange(value.nodeIdx, 0, content.nodes.length - 1)) add(errors, "pendingResult.nodeIdx", "PENDING_NODE_INDEX_INVALID", "主线节点索引无效");
			if (!isPlainObject(value.next) || value.next.kind !== "main" || !isIntegerInRange(value.next.nodeIdx, 0, content.nodes.length)) add(errors, "pendingResult.next", "PENDING_NEXT_INVALID", "主线结算目标无效");
			else if (value.next.nodeIdx !== value.nodeIdx + 1) add(errors, "pendingResult.next.nodeIdx", "PENDING_NEXT_MISMATCH", "主线结算目标不是下一节点");
			if (state.phase === "result" && value.nodeIdx !== state.nodeIdx) add(errors, "pendingResult.nodeIdx", "PENDING_STATE_MISMATCH", "结算节点不是当前节点");
		} else if (value.kind === "branch") {
			const node = getBranchNode(content, value.nodeId);
			if (!node) add(errors, "pendingResult.nodeId", "PENDING_BRANCH_UNKNOWN", "支线结算节点不存在");
			else if (!isIntegerInRange(value.choiceIdx, 0, node.choices.length - 1)) add(errors, "pendingResult.choiceIdx", "PENDING_CHOICE_INVALID", "支线选项不存在");
			if (state.phase === "result" && value.nodeId !== state.branchIdx) add(errors, "pendingResult.nodeId", "PENDING_STATE_MISMATCH", "支线结算节点不是当前节点");
			if (!isPlainObject(value.next) || value.next.kind !== "branch") add(errors, "pendingResult.next", "PENDING_NEXT_INVALID", "支线结算目标无效");
			else if (value.next.goto !== null && value.next.goto !== "FATE_HIGH" && value.next.goto !== "FATE_COST" && !getBranchNode(content, value.next.goto)) add(errors, "pendingResult.next.goto", "PENDING_GOTO_UNKNOWN", "支线 goto 不存在");
		}
	}
	function validateEndingInfo(value, state, content, errors) {
		if (value === null) return;
		if (!isPlainObject(value) || value.kind !== "main" && value.kind !== "fate") {
			add(errors, "endingInfo", "ENDING_INFO_INVALID", "endingInfo 类型无效");
			return;
		}
		if (value.kind === "main") {
			if (value.endingId !== null && !getEndingById(content, value.endingId)) add(errors, "endingInfo.endingId", "ENDING_ID_UNKNOWN", "主线结局 ID 不存在");
			if (!value.endingId && value.legacy !== true) add(errors, "endingInfo.endingId", "ENDING_ID_MISSING", "非历史主线结局必须记录 endingId");
			if (value.fateLineId !== null || value.variant !== null || value.branchId !== null) add(errors, "endingInfo", "ENDING_MAIN_FATE_FIELDS", "主线结局不能带支线字段");
		} else {
			if (!getFateLine(content, value.fateLineId)) add(errors, "endingInfo.fateLineId", "ENDING_FATE_UNKNOWN", "支线结局的 fateLineId 不存在");
			if (value.variant !== "high" && value.variant !== "cost" && value.legacy !== true) add(errors, "endingInfo.variant", "ENDING_VARIANT_INVALID", "支线结局 variant 无效");
			if (value.branchId !== null && value.branchId !== value.fateLineId) add(errors, "endingInfo.branchId", "ENDING_BRANCH_MISMATCH", "支线结局 branchId 不一致");
		}
		if (value.nodeId !== null && !getMainNodeById(content, value.nodeId) && !getBranchNode(content, value.nodeId)) add(errors, "endingInfo.nodeId", "ENDING_NODE_UNKNOWN", "结局节点不存在");
		if (value.year !== null && typeof value.year !== "string") add(errors, "endingInfo.year", "ENDING_YEAR_INVALID", "结局年份必须是字符串或 null");
		if (value.age !== null && typeof value.age !== "string") add(errors, "endingInfo.age", "ENDING_AGE_INVALID", "结局年龄必须是字符串或 null");
		if (state.phase !== "ended") add(errors, "endingInfo", "ENDING_PHASE_MISMATCH", "只有 ended 阶段可以带 endingInfo");
	}
	function validateNodePicks(value, content, errors) {
		if (!Array.isArray(value) || value.length > content.nodes.length) {
			add(errors, "nodePicks", "NODE_PICKS_INVALID", "nodePicks 长度或类型无效");
			return;
		}
		value.forEach((item, index) => {
			if (item === null || item === void 0 || item === -1) return;
			const node = content.nodes[index];
			if (!node || !isIntegerInRange(item, 0, node.choices.length - 1)) add(errors, `nodePicks[${index}]`, "NODE_PICK_INVALID", "主线选项索引无效");
		});
	}
	function validateDualPicks(value, content, errors) {
		if (!Array.isArray(value) || value.length > 3) {
			add(errors, "dualPicks", "DUAL_PICKS_INVALID", "dualPicks 必须是不超过三项的数组");
			return;
		}
		value.forEach((item, index) => {
			if (!isPlainObject(item) || item.sec !== index || !isIntegerInRange(item.choiceIdx, 0, ((content.nodes[0] || {}).choices || []).length - 1)) {
				add(errors, `dualPicks[${index}]`, "DUAL_PICK_INVALID", "N0 选择记录无效");
				return;
			}
			const choice = content.nodes[0].choices[item.choiceIdx];
			if (!choice || choice.sec !== item.sec) add(errors, `dualPicks[${index}]`, "DUAL_PICK_SECTION_INVALID", "N0 片段顺序无效");
		});
	}
	function validateBranchPicks(value, content, errors) {
		if (!Array.isArray(value)) {
			add(errors, "branchPicks", "BRANCH_PICKS_INVALID", "branchPicks 必须是数组");
			return;
		}
		const seen = /* @__PURE__ */ new Set();
		value.forEach((item, index) => {
			if (!isPlainObject(item) || typeof item.nodeId !== "string" || seen.has(item.nodeId)) {
				add(errors, `branchPicks[${index}]`, "BRANCH_PICK_INVALID", "支线选择记录无效或重复");
				return;
			}
			seen.add(item.nodeId);
			const node = getBranchNode(content, item.nodeId);
			if (!node || !isIntegerInRange(item.choiceIdx, 0, node.choices.length - 1)) add(errors, `branchPicks[${index}]`, "BRANCH_PICK_REFERENCE_INVALID", "支线选择引用无效");
			if (typeof item.result !== "string") add(errors, `branchPicks[${index}].result`, "BRANCH_RESULT_INVALID", "支线结果文本无效");
			validateDelta(item.delta, `branchPicks[${index}].delta`, errors);
		});
	}
	function validateState(state, content, options) {
		const c = normalizeContent(content);
		const errors = [];
		const strict = !options || options.strict !== false;
		if (!isPlainObject(state)) return {
			ok: false,
			errors: [{
				path: "",
				code: "STATE_NOT_OBJECT",
				message: "state 必须是对象"
			}]
		};
		if (strict) {
			Object.keys(state).forEach((key) => {
				if (!SERIALIZED_KEYS.includes(key)) add(errors, key, "FIELD_UNKNOWN", "存档包含未知字段");
			});
			SERIALIZED_KEYS.forEach((key) => {
				if (!Object.prototype.hasOwnProperty.call(state, key)) add(errors, key, "FIELD_MISSING", "存档缺少必需字段");
			});
		}
		if (state.schemaVersion !== c.schemaVersion) add(errors, "schemaVersion", "SCHEMA_VERSION_UNSUPPORTED", "schemaVersion 不受支持");
		if (!isIntegerInRange(state.nodeIdx, 0, c.nodes.length)) add(errors, "nodeIdx", "NODE_INDEX_INVALID", "nodeIdx 无效");
		else if (state.nodeIdx === c.nodes.length && state.done !== true) add(errors, "nodeIdx", "NODE_TERMINAL_RELATION_INVALID", "主线末尾索引只能出现在 ended 状态");
		if (!isPlainObject(state.attrs)) add(errors, "attrs", "ATTRS_NOT_OBJECT", "attrs 必须是对象");
		else {
			if (strict) Object.keys(state.attrs).forEach((key) => {
				if (!c.attrKeys.includes(key)) add(errors, `attrs.${key}`, "ATTR_UNKNOWN", "attrs 含未知属性");
			});
			c.attrKeys.forEach((key) => {
				if (!isFiniteNumber(state.attrs[key])) add(errors, `attrs.${key}`, "ATTR_NOT_FINITE", "属性必须是有限数字");
			});
		}
		AUX_KEYS.forEach((key) => {
			if (!isFiniteNumber(state[key])) add(errors, key, "AUX_NOT_FINITE", "辅助属性必须是有限数字");
		});
		validateFlags(state.flags, errors);
		validateNodePicks(state.nodePicks, c, errors);
		if (!Array.isArray(state.nodeDeltas) || state.nodeDeltas.length > c.nodes.length) add(errors, "nodeDeltas", "NODE_DELTAS_INVALID", "nodeDeltas 长度或类型无效");
		else state.nodeDeltas.forEach((item, index) => validateDelta(item, `nodeDeltas[${index}]`, errors));
		validateBranchPicks(state.branchPicks, c, errors);
		validateDualPicks(state.dualPicks, c, errors);
		validateStringCollection(state.deaths, "deaths", getAllowedDeathTypes(c), errors);
		validateStringCollection(state.endingsCollected, "endingsCollected", idsOf(c.endings), errors);
		validateStringCollection(state.fateCollected, "fateCollected", idsOf(c.fateLines), errors);
		validateStringCollection(state.eggs, "eggs", null, errors, { maxLength: 200 });
		validateStringCollection(state.achievements, "achievements", idsOf(c.achievements), errors);
		validateStringCollection(state.lifeTitles, "lifeTitles", idsOf(c.lifeTitles), errors);
		[
			"revives",
			"totalDeaths",
			"totalPlays",
			"legacyTotalPlays",
			"completedRuns",
			"power",
			"adPower",
			"adRevives"
		].forEach((key) => {
			if (!Number.isInteger(state[key]) || state[key] < 0) add(errors, key, "COUNTER_INVALID", "计数必须是非负整数");
		});
		if (!Number.isInteger(state.lastHotIdx) || state.lastHotIdx < -1) add(errors, "lastHotIdx", "LAST_HOT_INDEX_INVALID", "lastHotIdx 必须是 -1 或非负整数");
		if (typeof state.done !== "boolean") add(errors, "done", "DONE_INVALID", "done 必须是布尔值");
		if (typeof state.inFate !== "boolean") add(errors, "inFate", "IN_FATE_INVALID", "inFate 必须是布尔值");
		if (typeof state.runStarted !== "boolean") add(errors, "runStarted", "RUN_STARTED_INVALID", "runStarted 必须是布尔值");
		if (state.fateLineId !== null && !getFateLine(c, state.fateLineId)) add(errors, "fateLineId", "FATE_ID_UNKNOWN", "fateLineId 不存在");
		if (state.branchIdx !== null) {
			const branch = getBranchNode(c, state.branchIdx);
			if (!branch) add(errors, "branchIdx", "BRANCH_ID_UNKNOWN", "branchIdx 不存在");
			else if (state.fateLineId !== branch.line) add(errors, "branchIdx", "BRANCH_FATE_MISMATCH", "branchIdx 与 fateLineId 不一致");
		}
		if (!(state.mode === "main" || state.mode === "ended" || typeof state.mode === "string" && state.mode.startsWith("line:") && !!getFateLine(c, state.mode.slice(5)))) add(errors, "mode", "MODE_INVALID", "mode 无效");
		if (typeof state.mode === "string" && state.mode.startsWith("line:") && state.fateLineId !== state.mode.slice(5)) add(errors, "mode", "MODE_FATE_MISMATCH", "mode 与 fateLineId 不一致");
		if (!PHASES.includes(state.phase)) add(errors, "phase", "PHASE_INVALID", "phase 无效");
		if (state.adDate !== "" && (typeof state.adDate !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(state.adDate))) add(errors, "adDate", "AD_DATE_INVALID", "adDate 必须是 YYYY-MM-DD 或空字符串");
		if (state.lastHot !== null && typeof state.lastHot !== "string") add(errors, "lastHot", "LAST_HOT_INVALID", "lastHot 必须是字符串或 null");
		validateDelta(state.lastDelta, "lastDelta", errors);
		validateDelta(state.lastHotDelta, "lastHotDelta", errors);
		validateDeathInfo(state.deathInfo, c, errors);
		validatePendingResult(state.pendingResult, state, c, errors);
		validateEndingInfo(state.endingInfo, state, c, errors);
		if (!state.done && state.endingInfo !== null) add(errors, "endingInfo", "ENDING_NOT_TERMINAL", "未结束状态不能带 endingInfo");
		if (state.done) {
			if (state.phase !== "ended" || state.mode !== "ended" || state.pendingResult !== null || state.deathInfo !== null) add(errors, "phase", "ENDED_RELATION_INVALID", "ended 状态的阶段关系无效");
			if (state.inFate && !state.fateLineId) add(errors, "fateLineId", "ENDED_FATE_ID_MISSING", "支线终局缺少 fateLineId");
			if (!state.inFate && state.fateLineId !== null) add(errors, "fateLineId", "ENDED_MAIN_FATE_ID", "主线终局不能带 fateLineId");
			if (state.branchIdx !== null && !state.inFate) add(errors, "branchIdx", "ENDED_MAIN_BRANCH_ID", "主线终局不能带 branchIdx");
			if (state.endingInfo && (state.inFate && state.endingInfo.kind !== "fate" || !state.inFate && state.endingInfo.kind !== "main")) add(errors, "endingInfo", "ENDED_KIND_MISMATCH", "结局上下文与终局模式不一致");
		} else {
			if (state.mode === "ended") add(errors, "mode", "NON_TERMINAL_ENDED_MODE", "未结束状态不能使用 ended 模式");
			if (state.phase === "ended") add(errors, "phase", "NON_TERMINAL_ENDED_PHASE", "未结束状态不能使用 ended 阶段");
			if (state.inFate) {
				if (!state.fateLineId || state.mode !== `line:${state.fateLineId}`) add(errors, "mode", "NON_TERMINAL_FATE_RELATION_INVALID", "命运状态必须保持 line 模式与 fateLineId 一致");
				if (state.phase !== "fatePrompt" && (state.phase === "choosing" || state.phase === "result" || state.phase === "dead") && state.branchIdx === null) add(errors, "branchIdx", "NON_TERMINAL_BRANCH_MISSING", "支线进行中必须有 branchIdx");
			} else if (state.mode !== "main" || state.branchIdx !== null || state.fateLineId !== null) add(errors, "phase", "NON_FATE_MAIN_RELATION_INVALID", "非命运状态必须保持 main 模式且无支线引用");
			if (state.phase === "dead") {
				if (!state.deathInfo || state.pendingResult !== null) add(errors, "phase", "DEAD_RELATION_INVALID", "dead 必须有 deathInfo 且不能有 pendingResult");
			} else if (state.phase === "result") {
				if (!state.pendingResult || state.deathInfo !== null) add(errors, "phase", "RESULT_RELATION_INVALID", "result 必须有 pendingResult 且不能有 deathInfo");
			} else if (state.phase === "fatePrompt") {
				if (!state.inFate || !state.fateLineId || state.branchIdx !== null || state.pendingResult !== null || state.deathInfo !== null || state.mode !== `line:${state.fateLineId}`) add(errors, "phase", "FATE_PROMPT_RELATION_INVALID", "fatePrompt 关系无效");
			} else if (state.phase === "choosing") {
				if (state.pendingResult !== null || state.deathInfo !== null) add(errors, "phase", "CHOOSING_RELATION_INVALID", "choosing 不能带待结算或死亡信息");
				if (state.inFate && (!state.branchIdx || state.mode !== `line:${state.fateLineId}`)) add(errors, "phase", "BRANCH_CHOOSING_RELATION_INVALID", "支线 choosing 关系无效");
				if (!state.inFate && (state.mode !== "main" || state.branchIdx !== null || state.fateLineId !== null)) add(errors, "phase", "MAIN_CHOOSING_RELATION_INVALID", "主线 choosing 关系无效");
			}
		}
		if (state.pendingResult && state.phase !== "result") add(errors, "pendingResult", "PENDING_PHASE_MISMATCH", "pendingResult 只能出现在 result 阶段");
		if (state.deathInfo && state.phase !== "dead") add(errors, "deathInfo", "DEATH_PHASE_MISMATCH", "deathInfo 只能出现在 dead 阶段");
		if (!Array.isArray(state.pendingEggs) || state.pendingEggs.length > 100) add(errors, "pendingEggs", "PENDING_EGGS_INVALID", "pendingEggs 长度或类型无效");
		else state.pendingEggs.forEach((item, index) => {
			if (!isPlainObject(item) || typeof item.id !== "string" || typeof item.title !== "string" || typeof item.text !== "string") add(errors, `pendingEggs[${index}]`, "PENDING_EGG_INVALID", "彩蛋队列项无效");
		});
		COLLECTION_KEYS.forEach((key) => {
			if (!Array.isArray(state[key])) add(errors, key, "COLLECTION_NOT_ARRAY", "集合必须是数组");
		});
		return {
			ok: errors.length === 0,
			errors
		};
	}
	function assertValidState(state, content, options) {
		const result = validateState(state, content, options);
		if (!result.ok) {
			const error = /* @__PURE__ */ new Error("游戏状态校验失败");
			error.code = "STATE_INVALID";
			error.errors = result.errors;
			throw error;
		}
		return state;
	}
	module.exports = {
		assertValidState,
		validateState,
		validateSerializedState: validateState
	};
}));
//#endregion
//#region packages/game-core/src/migration.js
var require_migration = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var { normalizeContent } = require_content();
	var { SaveMigrationError, parseAndMigrate } = require_state();
	var { validateState } = require_validation();
	function migrateAndValidate(rawInput, content) {
		const report = parseAndMigrate(rawInput, content);
		const validation = validateState(report.state, normalizeContent(content), { strict: true });
		if (!validation.ok) throw new SaveMigrationError("SAVE_RELATION_INVALID", "存档迁移后未通过严格关系校验", validation.errors);
		return Object.assign({}, report, { validation });
	}
	module.exports = { migrateAndValidate };
}));
//#endregion
//#region packages/game-core/src/engine.js
var require_engine = /* @__PURE__ */ __commonJSMin(((exports, module) => {
	var { getAllowedDeathTypes, getBranchNode, getEndingById, getFateLine, getMainNode, normalizeContent, idsOf } = require_content();
	var { clone, createInitialState, isFiniteNumber, isIntegerInRange, isPlainObject, serializableDelta, serializeState } = require_state();
	var { validateState } = require_validation();
	var FIXED_TEXT = Object.freeze({
		n0Fool: "头脑简单四肢发达，废柴一枚——你光长力气不长脑子，3 岁就被判了死刑。",
		n0Nobody: "你光会认字看书，连吃都不会抢——身体太弱，三岁就体弱多病，查无此人，废柴一枚，余生碌碌无为。",
		broke: "你的资产跌破零线——全押爆仓、被冻结耗空，恭喜你变成大穷比了。韭菜毕业，从入门到破产只隔一场豪赌。",
		fool: "你的智力跌破 10——双抄袭引爆、瞒国籍败露、投机组合拳，小聪明无大智慧。饭桶一枚，你把自己算进去了。",
		killed: "你的运气跌破 10——硬闯海关、过河拆桥、得罪不该得罪的人。地下车库有人等你，你被暗杀了。停人房终身会员，欢迎入住。",
		coward: "你的能力跌破 10——不敢搏、不敢投、犹豫不决，出手慢了半辈子。怂包一枚，关键时刻掉链子认证。",
		nobody: "你的名气归零——连续沉默 + 名气自然衰减，查无此人，废柴一枚，余生碌碌无为。没有人记住你，包括你自己。",
		romance: "你跌入温柔乡直接破产——感情是你唯一的软肋，也是唯一的死穴。铁废物一枚，连心都守不住的人，守不住任何东西。",
		netbarEgg: "偷渡那晚，给你接头的\"蛇头\"居然是当年和你一起在网吧通宵的老网友。他认出了你：\"孙割！真的是你？\"你说：\"嘘——开船。\"这一晚，运气 +10。",
		xukeEgg: "KTV 散场后你清点那批 HSR，忽然想起徐可——那个让你免费装了一个礼拜办公室、说\"改天请你吃饭\"的人。后来波场市值千亿，你让秘书给她递了张 KTV 会员卡，附言：改天。她再也没等来你的改天——你从被割的人，变成了割人的人。",
		fatePreviewEgg: "2019 巴菲特午餐，你忽然感到一阵寒意——你的属性组合已经满足了一条归宿线的触发条件：「${name}」。命运从不缺席，只是迟到。你还有两年时间补救，或者……认命。"
	});
	function metricSnapshot(state, attrKeys) {
		const out = {};
		attrKeys.forEach((key) => {
			out[key] = state.attrs[key];
		});
		[
			"black",
			"risk",
			"rep",
			"clean"
		].forEach((key) => {
			out[key] = state[key];
		});
		return out;
	}
	function actualDelta(before, after, attrKeys) {
		const out = {};
		attrKeys.concat([
			"black",
			"risk",
			"rep",
			"clean"
		]).forEach((key) => {
			const value = after[key] - before[key];
			if (value !== 0) out[key] = value;
		});
		return out;
	}
	function applyDelta(state, delta, attrKeys) {
		if (!isPlainObject(delta)) return;
		attrKeys.forEach((key) => {
			if (isFiniteNumber(delta[key])) state.attrs[key] = (isFiniteNumber(state.attrs[key]) ? state.attrs[key] : 50) + delta[key];
		});
		[
			"black",
			"risk",
			"rep",
			"clean"
		].forEach((key) => {
			if (isFiniteNumber(delta[key])) state[key] += delta[key];
		});
	}
	function addAchievement(state, id, content) {
		if (!idsOf(content.achievements).includes(id)) return false;
		if (state.achievements.includes(id)) return false;
		state.achievements.push(id);
		return true;
	}
	function enqueueEgg(state, egg, effects) {
		if (!isPlainObject(egg)) return false;
		const id = typeof egg.id === "string" ? egg.id : typeof egg.title === "string" ? egg.title : null;
		if (!id) return false;
		if (state.pendingEggs.some((item) => item && (item.id || item.title) === id)) return false;
		const normalized = {
			id,
			title: String(egg.title || "彩蛋"),
			text: String(egg.text || "")
		};
		state.pendingEggs.push(normalized);
		if (effects) effects.push({
			type: "egg-queued",
			egg: clone(normalized)
		});
		return true;
	}
	function eggById(node, id) {
		if (node && Array.isArray(node.eggs)) {
			const match = node.eggs.find((egg) => egg && egg.id === id);
			if (match) return match;
		}
		return {
			id,
			title: "彩蛋",
			text: id
		};
	}
	function readRandom(context, purpose, effects) {
		if (!context || typeof context.random !== "function") {
			if (effects) effects.push({
				type: "random-defaulted",
				purpose,
				value: 0
			});
			return 0;
		}
		let value;
		try {
			value = context.random(purpose);
		} catch (error) {
			value = 0;
		}
		if (!isFiniteNumber(value)) value = 0;
		return Math.max(0, Math.min(.9999999999999999, value));
	}
	function checkDeath(state, choice) {
		const attrs = state.attrs;
		if (attrs.asset < 0) return {
			type: "broke",
			text: FIXED_TEXT.broke
		};
		if (attrs.intel < 10) return {
			type: "fool",
			text: FIXED_TEXT.fool
		};
		if (attrs.luck < 10) return {
			type: "killed",
			text: FIXED_TEXT.killed
		};
		if (attrs.ability < 10) return {
			type: "coward",
			text: FIXED_TEXT.coward
		};
		if (attrs.fame <= 0) return {
			type: "nobody",
			text: FIXED_TEXT.nobody
		};
		if (choice && choice.flag === "loveC2") return {
			type: "romance",
			text: FIXED_TEXT.romance
		};
		return null;
	}
	function registerDeath(state, death, content, sourceNodeId, branchId, effects) {
		const allowed = getAllowedDeathTypes(content);
		const info = {
			type: death && allowed.includes(death.type) ? death.type : allowed.includes("nobody") ? "nobody" : allowed[0],
			text: death && death.text ? String(death.text) : "这段人生提前结束了。",
			sourceNodeId: sourceNodeId || null,
			branchId: branchId || null
		};
		state.totalDeaths += 1;
		if (!state.deaths.includes(info.type)) state.deaths.push(info.type);
		state.deathInfo = info;
		state.pendingResult = null;
		state.phase = "dead";
		state.done = false;
		if (effects) effects.push({
			type: "death",
			death: clone(info)
		});
		return info;
	}
	function checkFate(state, completedNode, content) {
		const checkpoint = {
			N10: "CP1",
			N13: "CP2",
			N18: "CP3"
		}[completedNode && completedNode.id];
		if (!checkpoint) return null;
		const context = Object.assign({}, state.attrs);
		const hits = content.fateLines.filter((line) => line && line.cp === checkpoint && typeof line.cond === "function" && line.cond(context));
		hits.sort((a, b) => {
			const aDistance = Math.abs(state.attrs[a.mainAttr] - 50);
			const bDistance = Math.abs(state.attrs[b.mainAttr] - 50);
			if (aDistance !== bDistance) return bDistance - aDistance;
			return (a.order || 0) - (b.order || 0);
		});
		return hits[0] || null;
	}
	function endingContext(state) {
		return Object.assign({}, state.attrs, {
			black: state.black,
			risk: state.risk,
			rep: state.rep,
			clean: state.clean
		});
	}
	function resolveEnding(state, content) {
		const context = endingContext(state);
		for (const ending of content.endings) if (ending && typeof ending.cond === "function" && ending.cond(context)) return ending;
		return content.endings.length ? content.endings[content.endings.length - 1] : null;
	}
	function resolveLifeTitle(state, content) {
		const context = Object.assign({}, state.attrs);
		for (const title of content.lifeTitles) if (title && typeof title.cond === "function" && title.cond(context)) return title;
		return content.lifeTitles.length ? content.lifeTitles[content.lifeTitles.length - 1] : null;
	}
	function checkCommonAchievements(state, content) {
		if (state.nodePicks[5] !== void 0 && state.nodePicks[5] !== null && state.nodePicks[5] !== 2 && state.nodePicks[6] !== void 0 && state.nodePicks[6] !== null && state.nodePicks[6] !== 1) addAchievement(state, "no_cheat", content);
		if (state.nodePicks[8] === 1 && state.nodePicks[17] === 1 && state.nodePicks[21] === 1) addAchievement(state, "patience", content);
	}
	function mainChoiceChanges(state, node, choiceIdx, content, context, effects, options) {
		const choice = node.choices[choiceIdx];
		if (choice.flag) state.flags[choice.flag] = true;
		const before = metricSnapshot(state, content.attrKeys);
		applyDelta(state, choice.fx, content.attrKeys);
		if (node.id === "N6" && choiceIdx === 1 && state.flags.cheat5) applyDelta(state, { intel: -30 }, content.attrKeys);
		if (node.id === "N11" && choiceIdx === 0 && state.flags.n9a) applyDelta(state, { asset: -5 }, content.attrKeys);
		if (node.id === "N16" && choiceIdx === 1 && state.flags.netbar && (!options || options.allowRandom !== false)) {
			if (readRandom(context, "N16.netbar-helper", effects) < .5) {
				applyDelta(state, { luck: 10 }, content.attrKeys);
				enqueueEgg(state, {
					id: "netbar-helper",
					title: "「老网友接应」",
					text: FIXED_TEXT.netbarEgg
				}, effects);
			}
		}
		if (node.id === "N21" && (state.nodePicks[15] === 0 || state.nodePicks[20] === 1)) applyDelta(state, { fame: -5 }, content.attrKeys);
		if (node.id === "N24" && choiceIdx === 0 && state.flags.n23a) applyDelta(state, { risk: 30 }, content.attrKeys);
		if (choice.egg) enqueueEgg(state, eggById(node, choice.egg), effects);
		if (Array.isArray(node.eggs)) node.eggs.forEach((egg) => {
			if (egg && (egg.id === "handwash" || egg.id === "powerbank" || egg.id === "kuangchutai" || egg.id === "charity" && node.id === "N17" || egg.id === "zuoshou" && node.id === "N18")) enqueueEgg(state, egg, effects);
		});
		state.attrs.fame = Math.round(state.attrs.fame * .95);
		return actualDelta(before, metricSnapshot(state, content.attrKeys), content.attrKeys);
	}
	function endMain(state, content, effects) {
		const ending = state.endingInfo && state.endingInfo.kind === "main" && state.endingInfo.endingId ? getEndingById(content, state.endingInfo.endingId) || resolveEnding(state, content) : resolveEnding(state, content);
		state.done = true;
		state.mode = "ended";
		state.inFate = false;
		state.fateLineId = null;
		state.branchIdx = null;
		state.phase = "ended";
		state.pendingResult = null;
		if (ending && !state.endingsCollected.includes(ending.id)) state.endingsCollected.push(ending.id);
		state.completedRuns += 1;
		const lastNode = content.nodes[content.nodes.length - 1];
		state.endingInfo = {
			kind: "main",
			endingId: ending ? ending.id : null,
			fateLineId: null,
			variant: null,
			branchId: null,
			nodeId: lastNode ? lastNode.id : null,
			year: "2026",
			age: "36",
			legacy: false
		};
		const lifeTitle = resolveLifeTitle(state, content);
		if (lifeTitle && !state.lifeTitles.includes(lifeTitle.id)) state.lifeTitles.push(lifeTitle.id);
		if (state.revives === 0) addAchievement(state, "no_revive", content);
		checkCommonAchievements(state, content);
		effects.push({
			type: "ending",
			kind: "main",
			ending: ending ? clone(ending) : null,
			endingInfo: clone(state.endingInfo)
		});
	}
	function endFate(state, content, variant, effects) {
		const fate = getFateLine(content, state.fateLineId);
		if (!fate) return false;
		const chosen = variant === "cost" ? fate.cost : fate.high;
		if (!chosen) return false;
		const branchNode = state.branchIdx ? getBranchNode(content, state.branchIdx) : null;
		state.pendingResult = null;
		state.mode = "ended";
		state.inFate = true;
		state.done = true;
		state.phase = "ended";
		if (!state.fateCollected.includes(fate.id)) state.fateCollected.push(fate.id);
		if (state.fateCollected.length >= content.fateLines.length) addAchievement(state, "all_fate", content);
		if (state.revives === 0) addAchievement(state, "no_revive", content);
		checkCommonAchievements(state, content);
		state.completedRuns += 1;
		state.endingInfo = {
			kind: "fate",
			endingId: `${fate.id}:${variant}`,
			fateLineId: fate.id,
			variant,
			branchId: fate.id,
			nodeId: branchNode ? branchNode.id : null,
			year: branchNode ? branchNode.year : null,
			age: branchNode ? branchNode.age : null,
			legacy: false
		};
		const lifeTitle = resolveLifeTitle(state, content);
		if (lifeTitle && !state.lifeTitles.includes(lifeTitle.id)) state.lifeTitles.push(lifeTitle.id);
		effects.push({
			type: "ending",
			kind: "fate",
			fateLineId: fate.id,
			variant,
			chosen: clone(chosen),
			endingInfo: clone(state.endingInfo)
		});
		return true;
	}
	function refreshDailyQuota(state, day) {
		if (typeof day !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(day)) return false;
		if (state.adDate === day) return false;
		state.adDate = day;
		state.adPower = 5;
		state.adRevives = 3;
		return true;
	}
	function restartRun(state, content, day) {
		refreshDailyQuota(state, day);
		return createInitialState({
			endingsCollected: state.endingsCollected.slice(),
			deaths: state.deaths.slice(),
			fateCollected: state.fateCollected.slice(),
			eggs: state.eggs.slice(),
			achievements: state.achievements.slice(),
			totalDeaths: state.totalDeaths,
			totalPlays: state.totalPlays,
			legacyTotalPlays: state.legacyTotalPlays,
			completedRuns: state.completedRuns,
			lifeTitles: state.lifeTitles.slice(),
			adDate: state.adDate,
			adPower: state.adPower,
			adRevives: state.adRevives,
			power: 5,
			runStarted: true
		}, content);
	}
	function fullReset(state, content, day) {
		refreshDailyQuota(state, day);
		return createInitialState({
			adDate: state.adDate,
			adPower: state.adPower,
			adRevives: state.adRevives
		}, content);
	}
	function accepted(next, effects) {
		effects.push({ type: "persist" });
		return {
			state: next,
			effects
		};
	}
	function rejected(state, code, message, details) {
		return {
			state: clone(state),
			effects: [{
				type: "error",
				code,
				message,
				details: details || null
			}]
		};
	}
	function pickDual(state, action, content) {
		const effects = [];
		if (state.phase !== "choosing" || state.nodeIdx !== 0 || state.inFate || state.done) return rejected(state, "ACTION_NOT_ALLOWED", "当前阶段不能进行 N0 选择");
		const node = content.nodes[0];
		const section = state.dualPicks.length;
		const choice = node && node.choices && node.choices[action.choiceIdx];
		if (!choice || choice.sec !== section) return rejected(state, "CHOICE_INVALID", "N0 选择不属于当前片段");
		state.dualPicks.push({
			sec: choice.sec,
			choiceIdx: action.choiceIdx
		});
		if (state.dualPicks.length < 3) return accepted(state, effects);
		let hasIntel = false;
		let hasBody = false;
		state.dualPicks.forEach((pick) => {
			const selected = node.choices[pick.choiceIdx];
			if (selected.fx && selected.fx.intel > 0) hasIntel = true;
			if (selected.fx && selected.fx.ability > 0) hasBody = true;
		});
		if (!hasIntel || !hasBody) {
			state.nodePicks[0] = action.choiceIdx;
			registerDeath(state, {
				type: !hasIntel && hasBody ? "fool" : "nobody",
				text: !hasIntel && hasBody ? FIXED_TEXT.n0Fool : FIXED_TEXT.n0Nobody
			}, content, "N0", null, effects);
			return accepted(state, effects);
		}
		const before = metricSnapshot(state, content.attrKeys);
		state.dualPicks.forEach((pick) => applyDelta(state, node.choices[pick.choiceIdx].fx, content.attrKeys));
		state.lastDelta = actualDelta(before, metricSnapshot(state, content.attrKeys), content.attrKeys);
		addAchievement(state, "first_step", content);
		state.nodePicks[0] = 0;
		state.nodeIdx = 1;
		state.phase = "choosing";
		state.pendingResult = null;
		effects.push({
			type: "advance",
			mode: "main",
			nodeIdx: 1
		});
		return accepted(state, effects);
	}
	function advanceN0(state, content) {
		const effects = [];
		if (state.phase !== "choosing" || state.nodeIdx !== 0 || state.inFate || state.done || state.dualPicks.length !== 3) return rejected(state, "ACTION_NOT_ALLOWED", "当前没有可推进的 N0 校验");
		state.nodePicks[0] = 0;
		state.nodeIdx = 1;
		state.phase = "choosing";
		state.pendingResult = null;
		effects.push({
			type: "advance",
			mode: "main",
			nodeIdx: 1
		});
		return accepted(state, effects);
	}
	function pickMain(state, action, content, context) {
		const effects = [];
		if (state.phase !== "choosing" || state.done || state.inFate || state.mode !== "main") return rejected(state, "ACTION_NOT_ALLOWED", "当前阶段不能进行主线选择");
		if (action.nodeIdx !== state.nodeIdx) return rejected(state, "NODE_NOT_CURRENT", "选择不是当前主线节点");
		const node = getMainNode(content, action.nodeIdx);
		const choice = node && node.choices && node.choices[action.choiceIdx];
		const selected = state.nodePicks[action.nodeIdx];
		if (!node || !choice || !isIntegerInRange(action.choiceIdx, 0, node.choices.length - 1)) return rejected(state, "CHOICE_INVALID", "主线选项不存在");
		if (selected !== void 0 && selected !== null && selected !== -1) return rejected(state, "CHOICE_ALREADY_CONSUMED", "当前节点已经结算");
		state.nodePicks[action.nodeIdx] = action.choiceIdx;
		const delta = mainChoiceChanges(state, node, action.choiceIdx, content, context, effects);
		state.lastDelta = delta;
		state.nodeDeltas[action.nodeIdx] = delta;
		const death = choice.dead && (!choice.deadIf || state.flags[choice.deadIf]) ? choice.dead : checkDeath(state, choice);
		if (death) {
			registerDeath(state, death, content, node.id, null, effects);
			return accepted(state, effects);
		}
		state.pendingResult = {
			kind: "main",
			nodeId: node.id,
			nodeIdx: action.nodeIdx,
			choiceIdx: action.choiceIdx,
			title: node.title,
			result: choice.result || "",
			delta: serializableDelta(delta),
			next: {
				kind: "main",
				nodeIdx: action.nodeIdx + 1
			}
		};
		state.phase = "result";
		effects.push({
			type: "result",
			result: clone(state.pendingResult)
		});
		return accepted(state, effects);
	}
	function continueMainResult(state, content, context, effects) {
		const pending = state.pendingResult;
		if (pending.nodeIdx !== state.nodeIdx || pending.nodeId !== (getMainNode(content, state.nodeIdx) || {}).id) return false;
		state.pendingResult = null;
		state.phase = "choosing";
		state.nodeIdx = pending.next && isIntegerInRange(pending.next.nodeIdx, 0, content.nodes.length) ? pending.next.nodeIdx : pending.nodeIdx + 1;
		if (state.nodeIdx >= content.nodes.length) {
			endMain(state, content, effects);
			return true;
		}
		const completedNode = content.nodes[pending.nodeIdx];
		if (state.nodeIdx >= 18 && state.nodeIdx - state.lastHotIdx >= 2 && content.hotspots.length) {
			const hotspot = content.hotspots[Math.floor(readRandom(context, "HOTSPOT", effects) * content.hotspots.length)];
			const before = metricSnapshot(state, content.attrKeys);
			applyDelta(state, hotspot.fx, content.attrKeys);
			state.lastHot = hotspot.text;
			state.lastHotIdx = state.nodeIdx;
			state.lastHotDelta = actualDelta(before, metricSnapshot(state, content.attrKeys), content.attrKeys);
			addAchievement(state, "hotspot", content);
			effects.push({
				type: "hotspot",
				hotspot: clone(hotspot),
				delta: clone(state.lastHotDelta)
			});
		}
		const fate = checkFate(state, completedNode, content);
		if (fate) {
			state.inFate = true;
			state.fateLineId = fate.id;
			state.mode = `line:${fate.id}`;
			state.branchIdx = null;
			state.phase = "fatePrompt";
			effects.push({
				type: "fate-prompt",
				fateLineId: fate.id
			});
			return true;
		}
		state.inFate = false;
		state.fateLineId = null;
		state.mode = "main";
		if (completedNode && completedNode.id === "N13" && state.flags.learned) enqueueEgg(state, {
			id: "xuke",
			title: "「徐可的 20 万美金，从此再无下文」",
			text: FIXED_TEXT.xukeEgg
		}, effects);
		if (completedNode && completedNode.id === "N17") {
			const preview = content.fateLines.filter((line) => line && line.cp === "CP3" && typeof line.cond === "function" && line.cond(Object.assign({}, state.attrs)));
			if (preview.length) enqueueEgg(state, {
				id: `fate-preview-${preview[0].id}`,
				title: "「命运在敲门」",
				text: FIXED_TEXT.fatePreviewEgg.replace("${name}", preview[0].name)
			}, effects);
		}
		effects.push({
			type: "advance",
			mode: "main",
			nodeIdx: state.nodeIdx
		});
		return true;
	}
	function pickBranch(state, action, content) {
		const effects = [];
		if (state.phase !== "choosing" || state.done || !state.mode.startsWith("line:") || !state.branchIdx) return rejected(state, "ACTION_NOT_ALLOWED", "当前阶段不能进行支线选择");
		const node = getBranchNode(content, state.branchIdx);
		const choice = node && node.choices && node.choices[action.choiceIdx];
		if (!node || !choice || !isIntegerInRange(action.choiceIdx, 0, node.choices.length - 1)) return rejected(state, "CHOICE_INVALID", "支线选项不存在");
		const before = metricSnapshot(state, content.attrKeys);
		applyDelta(state, choice.fx, content.attrKeys);
		state.attrs.fame = Math.round(state.attrs.fame * .95);
		const delta = actualDelta(before, metricSnapshot(state, content.attrKeys), content.attrKeys);
		state.lastDelta = delta;
		const record = {
			nodeId: node.id,
			choiceIdx: action.choiceIdx,
			result: choice.result || "",
			delta: serializableDelta(delta)
		};
		const oldIndex = state.branchPicks.findIndex((item) => item.nodeId === node.id);
		if (oldIndex >= 0) state.branchPicks[oldIndex] = record;
		else state.branchPicks.push(record);
		const death = choice.dead && (!choice.deadIf || state.flags[choice.deadIf]) ? choice.dead : checkDeath(state, choice);
		if (death) {
			registerDeath(state, death, content, node.id, state.fateLineId, effects);
			return accepted(state, effects);
		}
		state.pendingResult = {
			kind: "branch",
			nodeId: node.id,
			choiceIdx: action.choiceIdx,
			title: node.title,
			result: choice.result || "",
			delta: serializableDelta(delta),
			next: {
				kind: "branch",
				goto: choice.goto
			}
		};
		state.phase = "result";
		effects.push({
			type: "result",
			result: clone(state.pendingResult)
		});
		return accepted(state, effects);
	}
	function continueBranchResult(state, content, effects) {
		const pending = state.pendingResult;
		if (pending.nodeId !== state.branchIdx) return false;
		const target = pending.next && pending.next.goto;
		if (target === "FATE_HIGH" || target === "FATE_COST") {
			state.pendingResult = null;
			state.phase = "choosing";
			return endFate(state, content, target === "FATE_COST" ? "cost" : "high", effects);
		}
		if (!target || !getBranchNode(content, target)) return false;
		state.pendingResult = null;
		state.phase = "choosing";
		state.branchIdx = target;
		effects.push({
			type: "advance",
			mode: state.mode,
			branchIdx: target
		});
		return true;
	}
	function transition(state, action, options) {
		const context = options || {};
		const content = normalizeContent(context.content || context);
		const validation = validateState(state, content, { strict: true });
		if (!validation.ok) return rejected(state, "STATE_INVALID", "游戏状态无法进入下一步", validation.errors);
		const next = clone(state);
		const input = action || {};
		switch (input.type) {
			case "PICK_DUAL": return pickDual(next, input, content);
			case "ADVANCE_N0":
			case "CONTINUE_N0": return advanceN0(next, content);
			case "PICK_MAIN": return pickMain(next, input, content, context);
			case "CONTINUE_RESULT": {
				const effects = [];
				if (next.phase !== "result" || !next.pendingResult) return rejected(next, "ACTION_NOT_ALLOWED", "当前没有待消费的结算");
				return (next.pendingResult.kind === "branch" ? continueBranchResult(next, content, effects) : continueMainResult(next, content, context, effects)) ? accepted(next, effects) : rejected(state, "PENDING_RESULT_INVALID", "结算目标与当前状态不一致");
			}
			case "START_BRANCH": {
				const effects = [];
				const fate = getFateLine(content, next.fateLineId);
				if (next.phase !== "fatePrompt" || !fate || !Array.isArray(fate.nodes) || !fate.nodes.length || !getBranchNode(content, fate.nodes[0])) return rejected(next, "ACTION_NOT_ALLOWED", "当前没有可进入的支线");
				next.branchIdx = fate.nodes[0];
				next.mode = `line:${fate.id}`;
				next.inFate = true;
				next.phase = "choosing";
				next.pendingResult = null;
				effects.push({
					type: "branch-started",
					fateLineId: fate.id,
					branchIdx: next.branchIdx
				});
				return accepted(next, effects);
			}
			case "PICK_BRANCH": return pickBranch(next, input, content);
			case "CHOOSE_FATE": {
				const effects = [];
				if (next.phase !== "fatePrompt" || !getFateLine(content, next.fateLineId) || input.variant !== "high" && input.variant !== "cost") return rejected(next, "ACTION_NOT_ALLOWED", "当前不能选择该归宿");
				const fate = getFateLine(content, next.fateLineId);
				if (Array.isArray(fate.nodes) && fate.nodes.length) return rejected(next, "ACTION_NOT_ALLOWED", "该归宿必须先进入支线");
				return endFate(next, content, input.variant, effects) ? accepted(next, effects) : rejected(next, "FATE_INVALID", "归宿结算失败");
			}
			case "REVIVE": {
				const effects = [];
				refreshDailyQuota(next, input.today !== void 0 ? input.today : context.today);
				if (next.phase !== "dead" || !next.deathInfo) return rejected(next, "ACTION_NOT_ALLOWED", "当前没有可复活的死亡进度");
				if (next.adRevives <= 0) return rejected(next, "REVIVE_QUOTA_EXHAUSTED", "今日看广告复活已用完");
				next.adRevives = Math.max(0, next.adRevives - 1);
				next.revives += 1;
				addAchievement(next, "first_revive", content);
				[
					"asset",
					"intel",
					"luck",
					"ability",
					"fame"
				].forEach((key) => {
					if (next.attrs[key] < 20) next.attrs[key] = Math.min(next.attrs[key] + 30, 50);
				});
				if (next.attrs.feel < 10) next.attrs.feel = Math.min(next.attrs.feel + 30, 50);
				if (next.nodeIdx === 0) {
					next.dualPicks = [];
					next.nodePicks[0] = -1;
				} else if (next.mode.startsWith("line:")) next.branchPicks = next.branchPicks.filter((item) => item.nodeId !== next.branchIdx);
				else delete next.nodePicks[next.nodeIdx];
				next.deathInfo = null;
				next.pendingResult = null;
				next.phase = "choosing";
				next.done = false;
				effects.push({
					type: "revived",
					nodeIdx: next.nodeIdx,
					branchIdx: next.branchIdx
				});
				return accepted(next, effects);
			}
			case "CONSUME_EGG": {
				const effects = [];
				if (!next.pendingEggs.length) return rejected(next, "EGG_QUEUE_EMPTY", "没有待展示彩蛋");
				const egg = next.pendingEggs.shift();
				if (!next.eggs.includes(egg.id || egg.title)) next.eggs.push(egg.id || egg.title);
				if (next.eggs.length >= 3) addAchievement(next, "egg_hunter", content);
				effects.push({
					type: "egg",
					egg: clone(egg)
				});
				return accepted(next, effects);
			}
			case "SYNC_DAILY_QUOTA": {
				const effects = [];
				if (!refreshDailyQuota(next, input.today !== void 0 ? input.today : context.today)) return rejected(next, "DATE_INVALID_OR_UNCHANGED", "日期无效或额度无需更新");
				effects.push({
					type: "daily-quota-reset",
					adDate: next.adDate
				});
				return accepted(next, effects);
			}
			case "RESTART": return accepted(restartRun(next, content, input.today !== void 0 ? input.today : context.today), [{ type: "run-restarted" }]);
			case "FULL_RESET": return accepted(fullReset(next, content, input.today !== void 0 ? input.today : context.today), [{ type: "full-reset" }]);
			default: return rejected(state, "ACTION_UNKNOWN", "未知游戏动作");
		}
	}
	function predictDeath(state, nodeIdx, choiceIdx, content, context) {
		const c = normalizeContent(content);
		const node = getMainNode(c, nodeIdx);
		if (!node || !node.choices || !node.choices[choiceIdx]) return null;
		const copy = clone(state);
		const choice = node.choices[choiceIdx];
		if (choice.flag) copy.flags[choice.flag] = true;
		mainChoiceChanges(copy, node, choiceIdx, c, context || {}, null, { allowRandom: false });
		if (choice.dead && (!choice.deadIf || copy.flags[choice.deadIf])) return clone(choice.dead);
		return checkDeath(copy, choice);
	}
	function createEngine(content) {
		const normalized = normalizeContent(content);
		return {
			content: normalized,
			createInitialState: (overrides) => createInitialState(overrides, normalized),
			migrateState: (raw, options) => require_state().migrateState(raw, normalized, options),
			serializeState: (state) => serializeState(state, normalized),
			validateState: (state) => validateState(state, normalized, { strict: true }),
			predictDeath: (state, nodeIdx, choiceIdx, context) => predictDeath(state, nodeIdx, choiceIdx, normalized, context),
			transition: (state, action, options) => transition(state, action, Object.assign({}, options, { content: normalized })),
			getEnding: (state) => resolveEnding(state, normalized),
			getFate: (id) => getFateLine(normalized, id)
		};
	}
	module.exports = {
		FIXED_TEXT,
		actualDelta,
		applyDelta,
		checkDeath,
		checkFate,
		createEngine,
		endingContext,
		predictDeath,
		resolveEnding,
		transition
	};
}));
//#endregion
//#region explicit ESM entry exports
var import_game_core = /* @__PURE__ */ __toESM((/* @__PURE__ */ __commonJSMin(((exports, module) => {
	var content = require_content();
	var state = require_state();
	var validation = require_validation();
	var migration = require_migration();
	var engine = require_engine();
	module.exports = Object.assign({}, content, state, validation, migration, engine);
})))(), 1);
var { AUX_KEYS, COLLECTION_KEYS, DEFAULT_ATTR_KEYS, DEFAULT_SCHEMA_VERSION, DELTA_KEYS, FIXED_TEXT, PHASES, SERIALIZED_KEYS, SaveMigrationError, actualDelta, applyDelta, assertValidState, checkDeath, checkFate, clone, contentSummary, createEngine, createInitialState, endingContext, getAllowedDeathTypes, getBranchNode, getEndingById, getFateLine, getMainNode, getMainNodeById, idsOf, isFiniteNumber, isIntegerInRange, isPlainObject, migrateAndValidate, migrateState, normalizeBranchPick, normalizeContent, normalizeDeathInfo, normalizeDualPick, normalizeEndingInfo, normalizePendingResult, parseAndMigrate, predictDeath, resolveEnding, serializableDelta, serializeState, transition, uniqueStrings, validateSerializedState, validateState } = import_game_core.default;
var game_core_default = import_game_core.default;
//#endregion
export { AUX_KEYS, COLLECTION_KEYS, DEFAULT_ATTR_KEYS, DEFAULT_SCHEMA_VERSION, DELTA_KEYS, FIXED_TEXT, PHASES, SERIALIZED_KEYS, SaveMigrationError, actualDelta, applyDelta, assertValidState, checkDeath, checkFate, clone, contentSummary, createEngine, createInitialState, game_core_default as default, endingContext, getAllowedDeathTypes, getBranchNode, getEndingById, getFateLine, getMainNode, getMainNodeById, idsOf, isFiniteNumber, isIntegerInRange, isPlainObject, migrateAndValidate, migrateState, normalizeBranchPick, normalizeContent, normalizeDeathInfo, normalizeDualPick, normalizeEndingInfo, normalizePendingResult, parseAndMigrate, predictDeath, resolveEnding, serializableDelta, serializeState, transition, uniqueStrings, validateSerializedState, validateState };
